<template>
  <div class = "footer_container" >
    <div class = "footer_content">
      <div class = "footer_logo footer-content-column">
        <div class = "logo-container">
          <img src = "../../../assets/img/index/logo1.png" alt = "">
          <div class="logo-text">
            <p class="text1">安澜保险经纪有限公司</p>
            <p class="text2">ANLAN INSURANCE BROKERS CO.,LTD.</p>
          </div>
        </div>
      <div>
          <h2>安澜保险经纪有限公司：91500105771753035P</h2>
          <h2>保险业务经营许可证：260700000000800</h2>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010502003089"><h2> 渝公网安备：50010502003089号 </h2></a>
          <a href="https://beian.miit.gov.cn"><h2> 网站备案号：渝ICP备2021001079号-1</h2></a>
      </div>
  </div>
      <div class = "about_us footer-content-column">
        <h2><router-link to = "/ours" target = "_blank" style="color: #fff;">关于我们</router-link></h2>
        <ul class = "contact_list">
            <li >
              <p class="text1">服务热线:400-023-9889 </p>
              <p class="text1">工作日（9:00-18:00）</p>
            </li>
        </ul>
      </div>
      <div class = "contact_us footer-content-column">
        <h2><router-link to = "/information" target = "_blank" style="color: #fff;">信息披露</router-link></h2>
        <ul class = "contact_list">
          <li>
            <a href="https://xyt.xinchacha.com/getpcInfo?sn=1537780609470922752&amp;certType=8&amp;url=*.cn-anlan.com">
              <img src="../../../assets/img/index/web_safe.png" alt="" style="height: 50px; width: 164px; ">
            </a>
          </li>
        </ul>
      </div>
      <div class = "focus_us footer-content-column">
        <h2>实时动态与产品信息，请扫码关注我们</h2>
        <div class = "media">
          <div :class = "item.name" v-for = "(item,index) in focus_icon" :key = "index">
            <el-popover
              placement = "top"
              trigger = "hover">
              <div class = "qr_popover">
                <img :src = "item.qr" alt = "" >
                <h2>{{ item.info }}</h2>
              </div>
              <img :src = "item.path" :alt = "item.name" slot = "reference">
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

      focus_icon: [
        {
          name: 'weibo',
          path: require('../../../assets/img/focus/weibo.png'),
          qr: require('../../../assets/img/focus/anlan_weibo.png'),
          info: '关注官方微博'
        },
        {
          name: 'weixin',
          path: require('../../../assets/img/focus/weixin.png'),
          qr: require('../../../assets/img/focus/anlan_weixin.png'),
          info: '关注官方微信公众号'
        },
        {
          name: 'douyin',
          path: require('../../../assets/img/focus/douyin.png'),
          qr: require('../../../assets/img/focus/anlan_douyin.png'),
          info: '关注官方抖音号'
        }
      ]
    }
  },
}
</script>

<style lang = "less" scoped>
*{
  margin: 0;
  padding: 0;
}
h2{
  font-size: 100%;
  font-weight: 400;
  font-variant: normal;
}
.footer_container {
  margin-top:auto ;
  width: 100%;
  background: #1f2329;
  padding-bottom: 10px;
}

.footer_content {
  max-width: 1440px;
  color: #fff;
  margin: 0 auto;
  padding: 69px 0 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  h2 {
    font-size: 14px;
    line-height: 22px;
    margin: 4px 0;
    color: #7b7e81;
  }

  .footer-content-column {
    flex: 1 1;
    color: #d2d3d4;
    position: relative;
    text-align: center;

    h2 {
      margin-bottom: 18px;
      font-size: 16px;
      font-weight: bold;
    }

    .about_list, .contact_list {
      padding:12px 0px 80px 0px;
      text-align: center;
      font-size: 14px;
      line-height: 22px;

      li {
        margin-bottom: 15px;
      }

      a {
        color: #d2d3d4;
      }
    }
  }

  .about_us, .contact_us {
    max-width: 202px;
  }

  .focus_us {
    text-align: left;
    padding-left: 73px;

    .media {
      margin: 30px;
      display: flex;
    }

    span {
      margin-right: 18px;
      flex: 0 0 auto;
    }

    img {
      width: 32px;
    }


    h2 {
      text-align: left;
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 4px;
    }
  }

  .footer_logo {
    margin-left: 96px;
    height: 55px;
    text-align: left;
    max-width: 382px;
    min-width: 350px;

    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 4px;
    }

    .logo-container {
      display: flex;
      margin-bottom: 9px;
      img {
        height: 50px;
      }
      .logo-text{
        margin-left: 15px;
        position: relative;
        bottom: -6px;
      }
      .text1{
        font-size: 21px;
        font-weight: bold;
        margin: 0;
      }
      .text2{
        font-size: 12px;
        margin: 0;
      }
    }
  }
}

.qr_popover {
  width: 100%;
  text-align: center;

  img {
    width: 130px;
    height: 130px;
    margin-bottom: 10px;
  }
}
</style>
